<template>
  <div id="app">
    <Header />
    <main>
      <!--transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition-->
      <keep-alive include="Offices">
        <router-view />
      </keep-alive>
    </main>
    <Footer />
    <Gdpr />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Gdpr from "@/components/Gdpr.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    Gdpr
  }
};
</script>

<style lang="scss">
#app {
  position: relative;
  // padding: 0 16px;
  // footer,
  main {
    position: relative;
    z-index: 2;
    background: $background;
  }
  main > div > section {
    padding: 0 16px;
  }
}

.container {
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
